import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormGroup, Label, Input } from 'reactstrap';
import Navigation from '../../components/Navigation/Navigation';
import Loading from '../../components/Loading/Loading';
import Slider from "react-slick";
import { updateQuestionAnswers } from '../../actions/verificationAction';
import { setVerificationQuestions, setVerificationSent } from '../../actions/applicationAction';
import { GetVerification, SubmitVerification } from '../../utils/ApplicationApi';
import withBackgroundImage from '../../HOC/withBackgroundImage';

import './ConfirmIdentity.scss';

class ConfirmIdentify extends Component {
  constructor(props) {
    super(props);

    this.state = { 
      slideIndex: 0,
      questions: [],
      viewedAllQuestions: false,
      isLoaded: false,
      showLoading: false, 
      showSubmitLoading: false
    };

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.selectAnswer = this.selectAnswer.bind(this);
    this.changeSlide = this.changeSlide.bind(this);
  }
  componentDidMount() {
    this.mounted = true;
    
    // Retrieve questions from API     
    if(this.props.application.applicationSent && !this.props.application.verificationSent) {
      this.setState({showLoading: true});
      GetVerification().then(result => {
        console.log("IN CONFIRMIDENTITY")
        console.log(result)
        if(result !== undefined) {
          if(this.mounted) {
            if(result !== null) {
              this.setState({showLoading: false,
              isLoaded: true,
              questions: result});
            }
            else {
              this.setState({showLoading: false});
              this.props.setVerificationSent(true);
              this.props.history.replace('/Submit');
            }
          }
        }
      }).catch(error => {
        // If the verification service is down, still go onto the next screen.
        this.setState({showLoading: false});
        this.props.setVerificationSent(true);
        this.props.history.replace('/Submit');
      });
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }  
  onClickForward() {
    // check that all the quesitons are answered 
    if(this.state.questions.filter(question => question.answer !== undefined).length === this.state.questions.length) {
      this.setState({
        showSubmitLoading: true,        
      });
      this.props.updateQuestionAnswers(this.state.questions);
      SubmitVerification(this.state.questions).then(result => {
        this.setState({showSubmitLoading: false});
        this.props.setVerificationSent(true);
        this.props.history.replace('/Submit');
      });
    }
  }
  onClickBackward() {
    this.props.history.replace('/IncomeExpenses');
  }
  selectAnswer(event) {
    let name =  event.target.name;
    let value = event.target.value;

    // If the element is selected using the keyboard and the enter key is pressed.
    if(event.key === "Enter" || event.key === " ") {
      name = event.target.querySelector("input").name;
      value = event.target.querySelector("input").value;
    }
    else if(event.type === "keydown") {
      return;
    }
    // Aet the answer element of the question object
    let questionIndex = this.state.questions.findIndex((question) => { return question.id === name });
    let question = this.state.questions[questionIndex];

    question.answer = value;

    this.setState({
      questions: [...this.state.questions.slice(0, questionIndex), question, ...this.state.questions.slice(questionIndex + 1)]
    }, () => {
      // Go to the next question, unless this is the last one and they haven't seen all the questions yet.
      if((this.state.slideIndex <= this.state.questions.length - 1) && !this.state.viewedAllQuestions) {
        this.slider.slickGoTo(this.state.slideIndex + 1);
      }
    });
  }
  changeSlide(index) {
    // If index equals the number of quetions, means, they already seen all the quetions. 
    let viewedAllQuestions = false
    if(index === this.state.questions.length - 1) {
      viewedAllQuestions = true;
    }

    this.setState({
      slideIndex: index,
      viewedAllQuestions: (!this.state.viewedAllQuestions ? viewedAllQuestions : this.state.viewedAllQuestions)
    });
  }
  render() {
    // Check if all the questions are answered, display the navigation
    let navigation;
    let slides;
    if(this.state.questions.filter(question => question.answer !== undefined).length === this.state.questions.length) {
      navigation = <Navigation onClickForward={this.onClickForward} />
    }

    if(this.state.isLoaded) {
      slides = this.state.questions.map((question, i) => {
        let questionIndex = i;
        return (
          <div key={i}>
            <p><b>{question.text}</b></p>
            {question.answers.map((answer, i) => {
              return (
                <FormGroup check key={i} className={(question.answer === answer) ? "checked": ""}>
                  <Label check tabIndex={questionIndex === this.state.slideIndex ? 0 : -1} onKeyDown={this.selectAnswer} >
                    <Input type="radio" name={question.id} onChange={this.selectAnswer} value={answer} checked={(question.answer === answer)} tabIndex="-1" /> {answer}
                    <div className="checkmark" />
                  </Label>
                </FormGroup>
              );
            })}
          </div>
        );
      });
    }

    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      afterChange: this.changeSlide
    };
    
    return (
      <div className="confirm-identity">
        <Loading visible={this.state.showLoading}>
          <div>Your information is being processed. We may have a few questions to verify your identity. This may take up to a few minutes.</div>
          <div>Please do not close or leave this page as your application will not be saved.</div>
        </Loading>
        <Loading visible={this.state.showSubmitLoading}>
          <div>Your answers are being processed. This may take up to a few minutes.</div>
          <div>Please do not close or leave this page as your application will not be saved.</div>
        </Loading>
        <h1>Please confirm your identity</h1>
        <p>These questions help us ensure that no one is impersonating you.</p>

        <Slider {...settings} ref={slider => (this.slider = slider)} >
          {slides}
        </Slider>
        <div className="navigation">
          {navigation}
        </div>
      </div>);
  }
}

const mapStateToProps = state => ({
  application: state.application
});

const mapDispatchToProps = dispatch => ({
  updateQuestionAnswers: (questions) => dispatch(updateQuestionAnswers(questions)),
  setVerificationQuestions: (verificationQuestions) => dispatch(setVerificationQuestions(verificationQuestions)),
  setVerificationSent: (verificationSent) => dispatch(setVerificationSent(verificationSent)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("review")(ConfirmIdentify));


// WEBPACK FOOTER //
// ./src/containers/ConfirmIdentity/ConfirmIdentity.js